import { getPaginationQuery } from "@/app/shared/utils/helpers";
import httpManager from "@/app/shared/utils/httpManager";
/**
 * Obtener tickets.
 *
 * @return {Promise<Array>} Lista de tickets.
 */
// export async function fetchActiveTickets({
//   queue = "",
//   channel = "",
//   identifier = "",
//   search = "",
//   read = "",
//   tag = "",
//   page,
// } = {}) {
//   // queue = queue == 0 ? "" : queue;
//   // channel = channel == 0 ? "" : channel;
//   const paginationQuery = getPaginationQuery(page, 10);
//   const response = await httpManager.get(
//     `/tickets/?${paginationQuery}&search=${search || ""}&queue=${queue || ""}&channel=${
//       channel || ""
//     }&read=${read}&tag=${tag}&channel_customer=${identifier || ""}`
//   );
//   return { tickets: response?.data?.results, nextPage: response.data?.next };
// }

function extractCursor(url) {
  if (!url) return null;
  const match = url.match(/(?:\?|&)cursor=([^&]+)/);
  console.log('extractCursor url, match: ', match ? decodeURIComponent(match[1]) : null);
  return match ? decodeURIComponent(match[1]) : null;
}

export async function fetchActiveTickets({
  queue = "",
  channel = "",
  identifier = "",
  search = "",
  read = "",
  tag = "",
  type_strategy = "",
  cursor = null,
  limit = 30,
} = {}) {
  // construimos query string
  const params = new URLSearchParams();

  if (cursor) params.append("cursor", cursor);
  if (limit) params.append("limit", limit);
  // if (search) params.append("search", search);
  // if (queue) params.append("queue", queue);
  // if (channel) params.append("channel", channel);
  // if (read) params.append("read", read);
  // if (tag) params.append("tag", tag);
  // if (identifier) params.append("channel_customer", identifier);

  const response = await httpManager.get(`/tickets/cursor/?${params.toString()}&search=${search || ""}&queue=${queue || ""}&channel=${
      channel || ""
    }&read=${read}&tag=${tag}&channel_customer=${identifier || ""}&type_strategy=${
      type_strategy || ""
    }`);

  console.log('fetchActiveTickets next: ', response?.data?.next);
  return {
    results: response?.data?.results || [],
    nextCursor: extractCursor(response?.data?.next),
    prevCursor: extractCursor(response?.data?.previous),
    channelsCount: response?.data?.channel_counts,
  };
}
